import apiConfig from '../api-config';
const api_base_url = apiConfig.api_base_url;
const api_key = apiConfig.api_key;

const webScanError = (message, code, card = false, data = null) => {
  const error = new Error(message);
  error.code = code;
  error.card = card;
  error.data = data;
  return error;
};

export const scanUrl = async (userId, url, options = {}) => {
  if (!userId || !url) {
    throw webScanError("User ID and URL are required", "INVALID_INPUT");
  }

  try {
    const token = sessionStorage.getItem("authToken");
    if (!token) {
      throw webScanError("Authentication token is missing", "UNAUTHORIZED");
    }

    const response = await fetch(
      `${api_base_url}/api/${api_key}/post/${userId}/web/scanUrl`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          url,
          authorizationConfirmed: options.authorizationConfirmed === true,
          activeScanAuthorized: options.activeScanAuthorized === true
        })
      }
    );

    const data = await response.json();
    if (!response.ok || data.success === false) {
      throw webScanError(
        data.message || "Request failed",
        data.code || "UNKNOWN_ERROR",
        data.meta?.showUpgradeCard || false,
        data.data || null
      );
    }

    return data;
  } catch (error) {
    console.error("Error posting user URL:", error.message);
    throw webScanError(
      error.message || "Network error",
      error.code || "NETWORK_ERROR",
      error.card || false,
      error.data || null
    );
  }
};
